"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Widget = require("./Widget");
Object.keys(_Widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Widget[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Widget[key];
    }
  });
});